module.exports = ['$scope', '$translate', '$utils',
  function ($scope, $translate, $utils) {
    $scope.currentUrl = location.origin + location.pathname

    $scope.copyToClipboard = function (event) {
      const copyInput = event.target.previousElementSibling
      const enableCopy = document.execCommand('copy')
      if (enableCopy) {
        copyInput.focus()
        copyInput.select()
      }

      try {
        if (document.execCommand('copy', false, null)) {
          console.log('copy success')
          $utils.$notify.set({message: $translate.instant('TIPS.COPY_LINK_SUCCESS')})
          copyInput.blur()
        } else {
          $utils.$notify.set({message: $translate.instant('TIPS.COPY_LINK_FAILED')})
          copyInput.select()
        }
      } catch (err) {
        $utils.$notify.set({message: JSON.stringify(err)})
      }
    }

    $scope.showNavigator = false
    $scope.showUserAgent = function () {
      $scope.showNavigator = !$scope.showNavigator
    }

    const navigatorMessage = []
    for (const key in navigator) {
      if (navigator[key]) {
        navigatorMessage.push(key + ': ' + JSON.stringify(navigator[key]))
      }
    }

    $scope.navigatorMessage = navigatorMessage
  }]



// WEBPACK FOOTER //
// ./src/js/controllers/introCtrl.js